// src/components/PropertyPanel/CommonProperties/ColorPickerControl.js
import React from 'react';
import { SketchPicker } from 'react-color';
import { usePropertyPanel } from '../PropertyPanelContext';
import { useSelector } from 'react-redux';
import { selectSelectedComponent } from '../../../redux/editorSlice';

const ColorPickerControl = ({ property, label, defaultColor }) => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const { handleStyleChange } = usePropertyPanel();
  const style = selectedComponent?.style || {};
  
  return (
    <div className="property-group">
      <label style={{ minWidth: '30%' }}>{label || '색상'}</label>
      <SketchPicker 
        color={style[property] || defaultColor || '#000000'} 
        onChange={(colorObj) => {
          if (selectedComponent) {
            handleStyleChange(selectedComponent, property, colorObj.hex);
          }
        }}
      />
    </div>
  );
};

export default ColorPickerControl;